function doesDataExist(data) {
    if (data === void 0) { data = {}; }
    return Object.keys(data || {}).length > 0;
}
export function getCurrentScript(scriptId) {
    var _a;
    // NOTE: in case currentScript doesn't have data attrs (dev mode or storybook)
    // we have to use it for element with ID
    var reactScript = doesDataExist((_a = document.currentScript) === null || _a === void 0 ? void 0 : _a.dataset)
        ? document.currentScript
        : document.getElementById(scriptId);
    return reactScript;
}
